import capitalizeFirstLetter from 'ToolboxUtils/general/capitalize-first-letter';

export default function daysForLocale(localeName = 'fr', capitalize = true, weekday = 'long') {
  const format = new Intl.DateTimeFormat(localeName, { weekday }).format;
  const wrap = capitalize ? capitalizeFirstLetter : x => x;
  return [...Array(7).keys()]
    .map((day) => wrap(format(new Date(Date.UTC(2021, 5, day)))));
}
